<ul class="registration-product-information">
	<li class="registration-product-information__item">
		@for (item of preloginProductList; track item) {
			<app-registration-product-information
				[preloginProduct]="item"
			></app-registration-product-information>
		}
	</li>
</ul>
